module.exports = __webpack_public_path__ + "assets/img/title-28532151.png";